var adultStepArr = [1,2,3,4];
var youthStepArr = [1,3,4];
var stepArr = adultStepArr;
var youthFlag = false;
var quizIndex = 0; 
var clickTimer;

var sizeFilterOpt = '';
var quizProducts = [];

$('body').on('click', 'button[quiz-advance]', function() {
  changeQuiz($(this));
});

$('body').on('click', 'input:radio[quiz-advance]', function() {
  changeQuiz($(this));
});
$('body').on('change', 'input[name="quizSport"]', function() {
  var checkedCount = $('input[name="quizSport"]:checked').length;
  if (checkedCount == 0) {
  	$('.calculateQuiz').attr('disabled', 'disabled');
  } else {
  	$('.calculateQuiz').removeAttr('disabled');
  }
  console.log(checkedCount);
});

$('body').on('click', '.averageAlert', function(event) {
  var modalContent = $('.alertContent .widthCont').html();
  Swal.fire({
    title: '<img src="https://cdn.shopify.com/s/files/1/3102/1374/files/icon-info.svg?v=1753827309" /> Average Face Width',
    html: modalContent,
    type: "warning",
    showConfirmButton: false,
    showCancelButton: false,
    showCloseButton: true,
    customClass: "wideModal"
  });
  event.stopPropagation(); 
  event.preventDefault();
});
$('body').on('click', '.swal2-html-container button', function() {
    var buttonAction = $(this).attr('data-action');
    console.log('buttonAction', buttonAction);
    if (buttonAction == 'average') {
      $('.quizBlock [data-size-filter="NewSize_Adult Average"]').prop('checked', true).trigger('click');
      setTimeout(function() {
        swal.close();
      }, 100);
    } else if (buttonAction == 'narrow') {
      $('.quizBlock [data-size-filter="NewSize_Adult Narrow"]').prop('checked', true).trigger('click');
      setTimeout(function() {
          swal.close();
      }, 100);
    } else if (buttonAction == 'wide') {
      $('.quizBlock [data-size-filter="NewSize_Adult Wide"]').prop('checked', true).trigger('click');
      setTimeout(function() {
          swal.close();
      }, 100);
    }
});
$('body').on('click', '.calculateQuiz', function() {
  $('.calculateQuiz').addClass('loading');
  setTimeout(function() {
    calculateQuiz();
  }, 100);
}); 

$('body').on('mouseover click', '.quizBlock .customCard .c-color-swatches__swatch', function() {
    console.log('swatch mouseover click global');
    var pCard = $(this).closest('.customCard');

    if (pCard.hasClass('htoCard')) {
      ///console.log('hto hover');
      var imgSrc = $(this).attr('data-image');
      var varURL = $(this).attr('data-url'); 
      pCard.find('.card__media img').attr('src', imgSrc);
        pCard.find('a').attr('href', varURL); 

        pCard.find('.c-color-swatches__swatch').removeClass('active');
        $(this).addClass('active');

    } else {
        var imgSrc = $(this).attr('data-image');
        var varURL = $(this).attr('data-url');
        var pColor = $(this).attr('data-handle');
        var pColorTitle = $(this).attr('title');

        var pSuffix = pCard.find('.overlayLink').attr('data-suffix');
        var pHref = pCard.find('.overlayLink').attr('data-href');
        var pType = $(this).closest('.product-card').attr('data-type');




        pCard.find('.product-card__image').attr('srcset', imgSrc);
        pCard.find('a').attr('href', varURL);

    

        if (imgSrc.indexOf(',') > -1) {
            var sizeW = '_' + imgSrc.split(', ')[1].split(' ')[1].replace('w', 'x');
            var origSrc = imgSrc.split(', ')[1].split(' ')[0].replace(sizeW, '');
            pCard.find('.product-card__image').attr('data-src', origSrc);
        }


        pCard.find('.c-color-swatches__swatch').removeClass('active');
        $(this).addClass('active');

        
    }


});

$('body').on('click', '.addToHTO', function() {
  addSelectedHTO($(this));
});

function closeQuiz() {
  

  if (window.location.pathname.indexOf('/pages/home-try-on-glasses') > -1) {
    window.location.href = '/collections/eyewear';
  } else {
    $('body').removeClass('quizOpen');
  }


} 
function changeQuiz(elem) {
  var int = 1;
  if (elem != undefined) {
    int = parseInt(elem.attr('quiz-advance'));  
  } 
  var ageVal = $('[name="quizAge"]:checked').val();
  if (ageVal != undefined && ageVal.indexOf('Youth') > -1) {
    stepArr = youthStepArr;
  } else {
    stepArr = adultStepArr;
  }
  quizIndex = quizIndex + int;
  setTimeout(function() {
    $('.quizContentBox').attr('data-step', stepArr[quizIndex]);
    $('.quizProgress').val(100 * ((quizIndex+1) / stepArr.length));
    $('.calculateQuiz').removeClass('loading');
  }, 300);
  
}


var sizefilterArr = ['NewSize_Youth 4-7', 'NewSize_Youth 8-12', 'NewSize_Youth 13-17', 'NewSize_Adult Narrow', 'NewSize_Adult Average', 'NewSize_Adult Wide'];
  
var prodHTOFound = 0;
var prodHTOHandles = [];
var htoLimit = 4;
var htoFilteredJSON = [];

function calculateQuiz() {
  console.log('calculateQuiz');
  var ts = Date.now();
  var collectionID = '462701625590'
  var shopDomain = 'libertysport.myshopify.com';

  var sizeParam = '';
  var sizeFilterOpt = $('input[data-size-filter]:checked').attr('data-size-filter') || '';
  if (sizeFilterOpt != '') {
      sizeParam = '&pf_t_sizes[]=' + sizeFilterOpt;
  }


  var selectedSportTexts = [];
  var sportParam = '';
  $('input[name="quizSport"]:checked').each(function() {
      var sportFilterVal = $(this).attr('data-sport-filter');
      var sportText = sportFilterVal.replace('Sport_', '').replace('Universal', 'Multi-Sport');
      selectedSportTexts.push(sportText);
      sportParam = sportParam + '&pf_t_sport[]=' + sportFilterVal;
  });

  var selectedSportText = selectedSportTexts.length > 1 ?
      selectedSportTexts.slice(0, -1).join(", ") + " and " + selectedSportTexts[selectedSportTexts.length - 1] :
      selectedSportTexts.join("");

  var pfsURL = 'https://services.mybcapps.com/bc-sf-filter/filter?t=' + ts + '&_=pf&shop=' + shopDomain + '&page=1&limit=20&sort=relevance&locale=en&event_type=filter&build_filter_tree=false&sid=932547b3-8500-4b0f-af42-297a5f3f2fa4&pg=collection_page' + sizeParam + sportParam + '&pf_st_stock_status[]=true&collection_scope=' + collectionID;



  $('.quizBlock .selectedSport').text(selectedSportText);


  $('.quizHTOResult').text(pfsURL);

  $.ajaxSetup({
      async: false
  });



  var htoResultJSON = [];
  $.ajax({
      url: pfsURL,
      method: "GET",
      dataType: "json",
      success: function(data) {
          console.log('pfsURL okay');
          htoResultJSON = data
      },
      error: function(xhr, status, error) {
          console.error("Error loading JSON:", error);
      }
  });


  //console.log($('input[data-size-filter]:checked').val());
  //console.log('111', pfsURL);
  prodHTOFound = 0;
  prodHTOHandles = [];
  htoFilteredJSON = [];
  var filteredProdCount = 0;

  console.log('hto htoResultJSON', htoResultJSON.products);
  $.each(htoResultJSON.products, function(index, prod) {
      console.log('htoResultJSON', prod.handle);
      var sizeVal = $('input[data-size-filter]:checked').val();

      filteredProdCount += 1;

      getQuizProduct(prod, sizeVal);


      console.log('hto prodVariant filteredProdCount', prod.handle, prodHTOFound, htoLimit);
      if (prodHTOFound >= htoLimit) {
          return false;
      }
  });


  console.log('prodVariant', htoFilteredJSON);
  //console.log(prodHTOFound);
  //console.log('push value', prodHTOFound, htoFilteredJSON);
  //console.log(prodHTOHandles);
  //console.log('prodHTOFound: '+prodHTOFound);
  //console.log('-----------');

  if (prodHTOFound < htoLimit) {
      var nextSizeArr = getSizes(sizeFilterOpt);
      console.log('hto prodVariant next size', sizeFilterOpt, nextSizeArr);
      $.each(nextSizeArr, function(index, nextSize) {

          if (prodHTOFound <= htoLimit) {
              //console.log('nnnn', prodHTOFound, htoLimit, prodHTOHandles);
              var nextIndex = index;
              //console.log(index + ': ' + value);
              sizeParam = '&pf_t_sizes[]=' + nextSize;

              var pfsURL = 'https://services.mybcapps.com/bc-sf-filter/filter?t=' + ts + '&_=pf&shop=' + shopDomain + '&page=1&limit=20&sort=relevance&locale=en&event_type=filter&build_filter_tree=false&sid=932547b3-8500-4b0f-af42-297a5f3f2fa4&pg=collection_page' + sizeParam + sportParam + '&pf_st_stock_status[]=true&collection_scope=' + collectionID;

              //$('.quizHTOResult').text(pfsURL);
              console.log('pfsURL', pfsURL);
              $.ajax({
                  url: pfsURL,
                  method: "GET",
                  dataType: "json",
                  success: function(data) {
                      //console.log(data); // Logs the JSON data
                      htoResultJSON = data
                  },
                  error: function(xhr, status, error) {
                      console.error("Error loading JSON:", error);
                  }
              });
              //$('.quizHTOResult').text(pfsURL);

              console.log('prodVariant nextSize', nextSize, 'nextIndex:' + nextIndex);
              //console.log('xxxxx', pfsURL, htoResultJSON.total_product);

              $.each(htoResultJSON.products, function(index, prod) {
                  console.log('hto prodVariant next prods', prod.handle);
                  if ($.inArray(prod.handle, prodHTOHandles) < 0) {
                      
                      if (prodHTOFound >= htoLimit) {
                          return false;
                      } else {
                        getQuizProduct(prod, nextSize);
                      }
                  }
              });
          }
      });

  }

  //console.log('xxxxx', prodHTOHandles);
  //console.log('xxxxx', htoFilteredJSON);


  renderHTOResult(htoFilteredJSON);

  



  $.ajaxSetup({
      async: true
  });
  changeQuiz();
} 
function getSizes(currentSize) {
    var currentIndex = sizefilterArr.indexOf(currentSize);

    if (currentIndex === -1) return []; // If size not found, return empty array

    var currentIndex = sizefilterArr.indexOf(currentSize);
    var quizSizePosition = currentIndex + 1;
    var quizSizeCount = sizefilterArr.length;
    console.log(quizSizePosition, quizSizeCount);

    var result = [];

    if (quizSizePosition == quizSizeCount) {
      //console.log('max get 2  down');
      result = sizefilterArr.slice(Math.max(0, currentIndex - 2), currentIndex);
    } else if (quizSizePosition == 1) {
      //console.log('2 up');
      result = sizefilterArr.slice(currentIndex + 1, Math.min(currentIndex + 3, sizefilterArr.length));
    } else if (quizSizePosition <= (quizSizeCount -1)) {
      //console.log('middle 1  up and 1 down');
      if (currentIndex + 1 < sizefilterArr.length) result.push(sizefilterArr[currentIndex + 1]); // One size up
      if (currentIndex - 1 >= 0) result.push(sizefilterArr[currentIndex - 1]); // One size down

    } 


    return result.reverse(); // Reverse the output
}
function getQuizProduct(prod, sizeVal) {
    var eyeSizeTag = 'NewSize:' + sizeVal + ':EyeSize_';
    var eyeSizeTagVal = prod.tags.filter(tag => tag.includes(eyeSizeTag));
    console.log('eyeSizeTagVal', prod.title, sizeVal, prod.tags, eyeSizeTag, eyeSizeTagVal);

    if (eyeSizeTagVal.length > 0) {
        eyeSizeTagVal = eyeSizeTagVal[0].replace(eyeSizeTag, '');
    }

    var availFlag = false;
    var variantAvailFound = 0;
    var variantsObj = [];
    $.each(prod.variants, function(index, variant) {
        var avail = variant.available;

        if (variant.title.indexOf(eyeSizeTagVal) > -1) {
            if (variant.available) {
                availFlag = true;
                var vTitle = variant.title;
                var vColor = vTitle.split(' / ')[0];
                var vSize = vTitle.split(' / ')[1];

                $.each(disableHto, function(index, item) {
                    var colorArr = item.Color.split(', ');
                    var sizeArr = item.Size.split(', ');
                    var colorFound = $.inArray(vColor, colorArr);
                    var sizeFound = $.inArray(vSize, sizeArr);
                    if (colorFound > -1 && sizeFound > -1) {
                        availFlag = false;
                    }
                });

                if (availFlag == true) {
                    //prodHTOHandles.push(prod.handle);
                    variantAvailFound += 1;
                    var variantEntry = {
                        id: variant.id,
                        title: vTitle,
                        color: vColor,
                        size: vSize,
                        available: variant.available,
                        sku: variant.sku,
                        image: variant.image
                    }
                    variantsObj.push(variantEntry);

                }

            }
        }

    }); // end loop variant 

    if (variantAvailFound > 0) {
        var prodEntry = {
            id: prod.id,
            handle: prod.handle,
            title: prod.title,
            //tags: prod.tags,
            variants: variantsObj
        }
        htoFilteredJSON.push(prodEntry);
        prodHTOFound += 1;
        prodHTOHandles.push(prod.handle);
        console.log('hto qqq', prod.handle, prodHTOFound);
    }
}

function renderHTOResult(htoFilteredJSON) {
  $('.quizHTOGrid').html('');
  $('.htoQuizCount').html(htoFilteredJSON.length);


  var htoGridTemplate = '<li><div class="customCard htoCard"><div class="product-card"><div class="card__media"><a href="{{url}}" title="{{title}}"><div class="media"><img src="{{image}}" alt="{{title}}"></div></a></div><div class="card__content"><div class="card__information"><div class="card-info title"><h3 class="card__heading"><a href="{{url}}" title="{{title}}">{{title}}</a></h3><div class="swatches-inner">{{swatchCode}}</div></div>{{lsImage}}</div></div></div></div></li>';

  var swatchEntryTemplate = '<label data-variant="{{vTitle}}" title="{{vColor}}" data-variantid="{{vID}}" data-url="{{vURL}}" data-variantsku="{{vSKU}}" class="c-color-swatches__swatch {{activeClass}}" data-image="{{vImage}}"><img loading="lazy" src="/cdn/shop/files/{{colorFile}}" alt="{{vColor}}"><div class="product-item-tooltip">{{vColor}}</div></label>';

  $.each(htoFilteredJSON, function(index, htoItem) {
    var htoIndex = index;
    var prodTitle = '<h5>'+htoItem.title+'</h5>';
    console.log('hto qqq', htoItem, htoItem.variants[0], htoItem.variants[0].image);
    var featImg = resizeHTOImg(htoItem.variants[0].image, '400x');

    var htoEntryCode = htoGridTemplate;
    var lsImgCode = '';
    htoEntryCode = htoEntryCode.replace(/{{title}}/g, htoItem.title);
    htoEntryCode = htoEntryCode.replace(/{{url}}/g, '/products/'+htoItem.handle);
    htoEntryCode = htoEntryCode.replace(/{{image}}/g, featImg);
    htoEntryCode = htoEntryCode.replace(/{{lsImage}}/g, lsImgCode);

    var swatchCode = '';
    $.each(htoItem.variants, function(index, htoVariant) {
      var variantImg = resizeHTOImg(htoVariant.image, '400x');
      var colorFile = slugify(htoVariant.color)+'_31x.jpg';
      var activeClass = '';
      if (index == 0) {
        activeClass = 'active';
      }

      swatchEntry = swatchEntryTemplate;
      swatchEntry = swatchEntry.replace(/{{vID}}/g, htoVariant.id);
      swatchEntry = swatchEntry.replace(/{{vTitle}}/g, htoVariant.title);
      swatchEntry = swatchEntry.replace(/{{vColor}}/g, htoVariant.color);
      swatchEntry = swatchEntry.replace(/{{vSKU}}/g, htoVariant.sku);
      swatchEntry = swatchEntry.replace(/{{vImage}}/g, variantImg);
      swatchEntry = swatchEntry.replace(/{{colorFile}}/g, colorFile);
      swatchEntry = swatchEntry.replace(/{{activeClass}}/g, activeClass);
      swatchEntry = swatchEntry.replace(/{{vURL}}/g, '/products/'+htoItem.handle+'?variant='+htoVariant.id);

      swatchCode += swatchEntry;
    });
    htoEntryCode = htoEntryCode.replace(/{{swatchCode}}/g, swatchCode);
    //console.log(htoEntryCode);
    $('.quizHTOGrid').append(htoEntryCode);

    $.get('/products/'+htoItem.handle+'?view=ls', function(data) {
      var imgCode = '<div class="card-info ls-image"><div class="ls-image-box">'+data+'</div></div>'
          $('.quizHTOGrid li:eq('+htoIndex+') .card__information').append(imgCode);
          //console.log('lslsls:'+htoIndex);
      });
  });
  setTimeout(function() {
      $('.quizHTOGrid .card-info.title').matchHeight({ property: 'min-height'});
    }, 600); 
  
}

function resizeHTOImg(imgPath, imgSize) {
  return imgPath.replace('.jpg', '_'+imgSize+'.jpg').replace('.png', '_'+imgSize+'.png')
}
function slugify(text) {
    return text
        .toString()                      // Ensure it's a string
        .toLowerCase()                   // Convert to lowercase
        .trim()                           // Remove extra spaces
        .replace(/[\s\W-]+/g, '-')        // Replace spaces and special characters with dashes
        .replace(/^-+|-+$/g, '');         // Remove leading and trailing dashes
}



function addSelectedHTO(elem) {
  elem.addClass('loading');
  var htoVariant = theme.custom.htoProduct;
  var properties = {};
  quizProducts = [];
  $('.quizHTOGrid .htoCard').each(function(index) {
    var pNum = index + 1;
    var pName = $(this).find('.card__heading').text();
    var activeSwatch = $(this).find('.c-color-swatches__swatch.active');
    var pColor = activeSwatch.attr('title');
    var pVariant = ' | '+activeSwatch.attr('data-variant');
    var pSKU = activeSwatch.attr('data-variantsku');
    var pURL = activeSwatch.attr('data-url');
    var pImg = activeSwatch.attr('data-image');
    var eyeSize = pVariant.match(/\d+/)[0]; 
    var variantId = activeSwatch.attr('data-variantid');
    var pSize = activeSwatch.attr('data-variant').split(' / ')[1];
    console.log(eyeSize);
    properties['HomeTryOn #' + pNum] = pName + pVariant;
    properties['_HomeTryOn #' + pNum +' URL'] = pURL;
    properties['_HomeTryOn #' + pNum +' Image'] = pImg;
    properties['_HomeTryOn #' + pNum + ' SKU'] = pSKU;
    properties['_HomeTryOn #' + pNum + ' eyeSize'] = eyeSize;
    properties['_HomeTryOn #' + pNum + ' HR'] = '----------';

    //setQuizLocalStorage(pName,variantId,variantSize,frameSize,imageURL,variantURL,variantColor,chkId,triggerClass, sku, eyeSize) 
    var product = {
      uid: createUUID(),
      productname: pName,
      variantid: variantId,
      size: pSize,
      framesize: pSize,
      imageurl: pImg,
      url: pURL,
      variantcolor: pColor,
      sku: pSKU,
      eyeSize: eyeSize
    };
    quizProducts.push(product);
    localStorage.setItem("products", JSON.stringify(quizProducts));

  });

  
  jQuery.getJSON('/cart.js', function(cart) {
      var htoVariant = theme.custom.htoProduct;
      var htoFound = false;

      // Check if the product is already in the cart
      jQuery.each(cart.items, function(index, item) {
          if (item.id === htoVariant) {
              htoFound = true;
              // Remove the existing product first
              jQuery.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: { id: item.key, quantity: 0 },
                  dataType: 'json',
                  success: function() {
                      // Add a new instance after removing the old one
                      jQuery.ajax({
                          type: 'POST',
                          url: '/cart/add.js',
                          data: { id: htoVariant, quantity: 1, properties: properties },
                          dataType: 'json',
                          success: function() {
                              console.log('Product replaced in cart.');
                              window.location.href = '/cart';
                          }
                      });
                  }
              });
              return false; // Break out of the loop
          }
      });

      // If not found, add the product
      if (!htoFound) {
          jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: { id: htoVariant, quantity: 1, properties: properties },
              dataType: 'json',
              success: function() {
                  console.log('Product added to cart.');
                  window.location.href = '/cart';
              }
          });
      }
  });

}





function createUUID(){
  // http://www.ietf.org/rfc/rfc4122.txt
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}


var $stickies = $('.quizBlock h2');
var $scrollContainer = $('.quizBlock');
var scrollTimer;



$scrollContainer.on('scroll', function() {
  clearTimeout(scrollTimer);
  scrollTimer = setTimeout(function() {
    $stickies.each(function() {
      var rectTop = this.getBoundingClientRect().top;

      if (rectTop == 70) {
        $(this).addClass('sticky');
      } else {
        $(this).removeClass('sticky');

      }
    });
    
    // var btnRectTop = $('.quizButtonBox')[0].getBoundingClientRect().top;
    // var viewportHeight = $(window).height();
    // var btnBoxHeight = $('.quizButtonBox').outerHeight();
    // var recBound = viewportHeight - btnBoxHeight;
    // if (btnRectTop == recBound) {
    //   $('.quizButtonBox').addClass('sticky');
    // } else {
    //   $('.quizButtonBox').removeClass('sticky');
    // }
    // console.log(btnRectTop, recBound);

  }, 100);
});
/*
$(document).ready(function() {
  checkQuizBtn()
});

function checkQuizBtn() {
  var quizHt = $('.quizContent').height(); 
  var quizSportHt = $('.quizBlock[data-step="3"]')[0].scrollHeight; 

  if (quizHt < quizSportHt) {
    $('.quizButtonBox').addClass('sticky');
  }
}
*/